import CryptoJS from 'crypto-js'
// 使用示例
// const encryptedData = '5Wbcawug_beHgA4G4yRMQpG-loRCSvqboE7EcyvA9rQylOB0dzn8whc-Fasmxsfraj8s0jEp_j5SkGI9fCLTyFmuPW2nNV8Vq55Cd4uIDXM' // 不带 padding 的 Base64Url
const secretKey = 'YourSecretKey123' // 16/24/32字节长度

export default{
  encryptData(value) {
    // 1. 准备密钥（直接使用UTF-8编码的密钥）
    const key = CryptoJS.enc.Utf8.parse(secretKey)

    // 2. 执行加密（ECB模式，PKCS7填充）
    const encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(value),
      key,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }
    )

    // 3. 转换为Base64 URL安全格式（不带填充）
    let base64Url = encrypted.toString()
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '')

    return base64Url
  }

}




// try {
//     const decrypted = decryptBackendData(encryptedData, secretKey)
//     console.log('解密结果:', decrypted)
// } catch (error) {
//     console.error('解密失败:', error)
// }
